import React, { useEffect, useRef, useState } from 'react'
import SelectBox from 'devextreme-react/select-box';
import { useTranslation } from 'react-i18next';
import { useShop } from '../../../Providers/ShopProvider';

import './Styles/SortingDropDownStyles.css'

const SortingDropDown = ({ }) => {
    const { t } = useTranslation()
    const options = [
        { id: 0, name: t('HomePage.SortingSelector.placeholder') },
        { id: 2, name: t('HomePage.SortingSelector.priceDesc') },
        { id: 1, name: t('HomePage.SortingSelector.priceAsc') },
        { id: 3, name: t('HomePage.SortingSelector.nameAZ') },
        // { id: 4, name: t('HomePage.SortingSelector.nameZA') },
        { id: 5, name: t('HomePage.SortingSelector.indexAsc') },
        // { id: 6, name: t('HomePage.SortingSelector.indexDesc') },
    ]
    const { productsFilter, setProductsFilter } = useShop()
    const [sortingTypeSelected, setSortingTypeSelected] = useState(productsFilter.SortType)

    const handleSelectBoxChange = (e) => {
        if (e.value !== undefined) {
            setSortingTypeSelected(e.value)
            setProductsFilter(prev => ({
                ...prev,
                SortType: e.value
            }))
        }
    }

    return (
        <>
            <SelectBox
                className="sorting-drop-down-selectbox"
                dataSource={options}
                value={sortingTypeSelected}
                placeholder={t('HomePage.SortingSelector.placeholder')}
                valueExpr="id"
                displayExpr="name"
                onValueChanged={(e) => handleSelectBoxChange(e)}
            />
        </>
    )
}

export default SortingDropDown